import { INITIALIZE_SUCCESS, SET_BREADCRUMBS, SET_LAST_BREADCRUMBS,
  PUSH_BREADCRUMBS, SET_PAGE_HEAD } from '../constants/app';
import { getAuthUserData } from './auth';
import { getDifficultyList, getTonalityList } from './shop';

const initializeSuccess = () => ({ type: INITIALIZE_SUCCESS });
const setBreadcrumbs = (breadcrumbs) => ({ type: SET_BREADCRUMBS, breadcrumbs });
const setLastBreadcrumbs = (breadcrumbs) => ({ type: SET_LAST_BREADCRUMBS, breadcrumbs });
const pushBreadcrumbs = (breadcrumbs) => ({ type: PUSH_BREADCRUMBS, breadcrumbs });
const setPageHead = (pageHead) => ({ type: SET_PAGE_HEAD, pageHead });

export const initializeApp = () => (dispatch) => {
  /* первоначальная ицициализация приложения: */
  Promise.all([
    // получение данных об авторизации и общих данных о пользователе
    dispatch(getAuthUserData()),
    // получение списка "Сложность" из магазина
    dispatch(getDifficultyList()),
    // получение списка "Тональность" из магазина
    dispatch(getTonalityList())
  ]).then(() => { dispatch(initializeSuccess()) });
};

export const setBreadcrumbsArray = (breadcrumbs) => (dispatch) => {
  dispatch(setBreadcrumbs(breadcrumbs));
};

export const addItemToBreadcrumbsArray = (breadcrumbs) => (dispatch) => {
  dispatch(pushBreadcrumbs(breadcrumbs));
};

export const setLastBreadcrumbsArray = (breadcrumbs) => (dispatch) => {
  dispatch(setLastBreadcrumbs(breadcrumbs));
};

export const setPageHeadObject = (pageHead) => (dispatch) => {
  dispatch(setPageHead(pageHead));
};

